import styled from 'styled-components'

export const NavigationStyle = styled.nav`
    position: sticky;
    top: 0;
    z-index: 1000;
    display: flex;
    width: 100%;

    background-color: ${(props) => props.theme.navigationResponsive.dataArea.background};
    color: ${(props) => props.theme.navigationResponsive.dataArea.miniTextColor};
`
export const MainContainerStyle = styled.div`
    display: flex;
    align-items: center;

    justify-content: space-between;
    width: 100%;
`
